const ALL_PRODUCTS_URL = window.ALL_PRODUCTS_URL || '/collections/all';
const CURRENT_COLLECTION_URL = window.CURRENT_COLLECTION_URL || ALL_PRODUCTS_URL;

document.addEventListener('DOMContentLoaded', () => {
    const stickyBar = document.getElementById('mobile-sticky-bar');
    const drawer = document.getElementById('mobile-filter-drawer');
    const drawerPanel = drawer?.querySelector('.transform');
    const productGrid = document.getElementById('product-grid');
    const breadcrumbText = document.getElementById('breadcrumb-text');

    const desktopChecks = document.querySelectorAll('.js-filter-checkbox');
    const mobileChecks = document.querySelectorAll('.js-mobile-filter-checkbox');

    // Filter Tags Elements
    const filterTagsContainer = document.getElementById('desktop-filter-tags');
    const removeAllLink = document.getElementById('desktop-remove-all');
    const categoryCount = document.getElementById('desktop-category-count');

    // Price & Availability Elements / State (Shared across renderFilterTags and runCombinedFilters)
    const priceMinInput = document.getElementById('price-min');
    const priceMaxInput = document.getElementById('price-max');
    const mobilePriceMinInput = document.getElementById('mobile-price-min');
    const mobilePriceMaxInput = document.getElementById('mobile-price-max');
    const clearPriceBtn = document.getElementById('clear-price-filter');
    let activePriceMin = null;
    let activePriceMax = null;

    const inStockFilter = document.getElementById('filter-in-stock');
    const mobileInStockFilter = document.getElementById('mobile-filter-in-stock');

    function isPriceFilterActive() {
        return activePriceMin !== null || activePriceMax !== null;
    }

    // Pagination Elements
    const serverPagination = document.getElementById('server-pagination');
    const clientPagination = document.getElementById('client-pagination');
    const PRODUCTS_PER_PAGE = window.PRODUCTS_PER_PAGE || 12;

    // Client-side pagination state
    let currentPage = 1;

    // -----------------------------
    // ✅ Skeleton Loader (S3 - Zero CLS)
    // -----------------------------
    function showSkeletonLoader(count = 8) {
        if (!productGrid) return;
        const skeletonCard = `
            <div class="flex flex-col h-full bg-white rounded-xl md:rounded-2xl overflow-hidden border border-[#e9f1e9]" aria-hidden="true">
                <div class="aspect-square bg-gray-200 skeleton-shimmer"></div>
                <div class="p-3 md:p-6 flex flex-col gap-2">
                    <div class="h-4 bg-gray-200 skeleton-shimmer rounded w-3/4"></div>
                    <div class="h-4 bg-gray-200 skeleton-shimmer rounded w-1/2"></div>
                    <div class="h-4 bg-gray-200 skeleton-shimmer rounded w-1/3 mt-1"></div>
                    <div class="h-10 bg-gray-200 skeleton-shimmer rounded-lg mt-2"></div>
                </div>
            </div>
        `;
        productGrid.innerHTML = Array(count).fill(skeletonCard).join('');
    }

    // Helper to eagerly load top-viewport cards right when injected into DOM (M3 Fix - Zero CLS)
    function prepareCardForInjection(card, index) {
        if (index <= 3) {
            const img = card.querySelector('img');
            if (img) {
                img.setAttribute('loading', 'eager');
                img.setAttribute('fetchpriority', 'high');
            }
        }
        return card;
    }

    let allProducts = [];

    // Helper to update product counts dynamically
    function updateProductCount(count) {
        const countElements = document.querySelectorAll('.js-product-count');
        countElements.forEach((el) => {
            if (el.tagName.toLowerCase() === 'span') {
                el.textContent = `${count} product${count === 1 ? '' : 's'}`;
            } else {
                el.textContent = `Showing ${count} item${count === 1 ? '' : 's'}`;
            }
        });
    }

    // -----------------------------
    // ✅ Client-Side Pagination System
    // -----------------------------
    function hideServerPagination() {
        if (serverPagination) {
            serverPagination.classList.add('hidden');
        }
    }

    function showServerPagination() {
        if (serverPagination) {
            serverPagination.classList.remove('hidden');
        }
    }

    function renderClientPagination(totalProducts) {
        if (!clientPagination) return;

        const totalPages = Math.ceil(totalProducts / PRODUCTS_PER_PAGE);

        // Hide pagination if only 1 page or no products
        if (totalPages <= 1) {
            clientPagination.classList.add('hidden');
            clientPagination.innerHTML = '';
            return;
        }

        clientPagination.classList.remove('hidden');

        // Build pagination HTML
        let paginationHTML = `
            <p class="text-center text-sm text-text-subtle mt-12 lg:mt-16 mb-4">
                Page ${currentPage} of ${totalPages}
            </p>
            <nav class="flex items-center justify-center gap-3 sm:gap-4 pb-8" aria-label="Pagination">
                <!-- Previous Button -->
                <button 
                    id="client-prev-btn"
                    class="flex items-center gap-2 px-4 py-3 sm:px-5 sm:py-3 text-sm font-medium ${currentPage === 1 ? 'text-gray-300 bg-gray-50 border-gray-200 cursor-not-allowed' : 'text-text-main bg-white border-secondary/30 hover:bg-primary hover:text-white hover:border-primary'} border rounded-xl transition-all duration-200 shadow-sm"
                    ${currentPage === 1 ? 'disabled' : ''}
                    aria-label="Go to previous page"
                >
                    <span class="material-symbols-outlined text-[18px]">chevron_left</span>
                    <span>Prev</span>
                </button>

                <!-- Page Numbers -->
                <div class="flex items-center gap-2 sm:gap-3">
        `;

        // First page
        paginationHTML += renderPageButton(1, totalPages);

        // Left ellipsis
        if (currentPage > 3) {
            paginationHTML += `<span class="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center text-text-subtle text-lg">…</span>`;
        }

        // Middle pages
        for (let page = 2; page < totalPages; page++) {
            const diff = Math.abs(currentPage - page);
            const showPage = diff <= 1 ||
                (currentPage <= 2 && page === 2) ||
                (currentPage >= totalPages - 1 && page === totalPages - 1);

            if (showPage) {
                paginationHTML += renderPageButton(page, totalPages);
            }
        }

        // Right ellipsis
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center text-text-subtle text-lg">…</span>`;
        }

        // Last page
        if (totalPages > 1) {
            paginationHTML += renderPageButton(totalPages, totalPages);
        }

        paginationHTML += `
                </div>

                <!-- Next Button -->
                <button 
                    id="client-next-btn"
                    class="flex items-center gap-2 px-4 py-3 sm:px-5 sm:py-3 text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 bg-gray-50 border-gray-200 cursor-not-allowed' : 'text-text-main bg-white border-secondary/30 hover:bg-primary hover:text-white hover:border-primary'} border rounded-xl transition-all duration-200 shadow-sm"
                    ${currentPage === totalPages ? 'disabled' : ''}
                    aria-label="Go to next page"
                >
                    <span>Next</span>
                    <span class="material-symbols-outlined text-[18px]">chevron_right</span>
                </button>
            </nav>
        `;

        clientPagination.innerHTML = paginationHTML;

        // Add event listeners
        document.getElementById('client-prev-btn')?.addEventListener('click', () => {
            if (currentPage > 1) {
                goToPage(currentPage - 1);
            }
        });

        document.getElementById('client-next-btn')?.addEventListener('click', () => {
            if (currentPage < totalPages) {
                goToPage(currentPage + 1);
            }
        });

        clientPagination.querySelectorAll('.client-page-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const page = parseInt(btn.dataset.page);
                goToPage(page);
            });
        });
    }

    function renderPageButton(page, totalPages) {
        const isActive = page === currentPage;
        return `
            <button 
                class="client-page-btn w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center text-sm font-${isActive ? 'bold' : 'semibold'} ${isActive ? 'text-white bg-primary border-primary shadow-md' : 'text-text-main bg-white border-secondary/30 hover:bg-primary hover:text-white hover:border-primary'} border rounded-xl transition-all duration-200 shadow-sm"
                data-page="${page}"
                ${isActive ? 'aria-current="page"' : ''}
                aria-label="${isActive ? 'Current page, page' : 'Go to page'} ${page}"
            >
                ${page}
            </button>
        `;
    }

    function goToPage(page) {
        currentPage = page;
        showProductsForPage(currentPage);
        renderClientPagination(allProducts.length);

        // Scroll to top of product grid accounting for sticky header & filter bar offset
        if (productGrid) {
            const header = document.querySelector('#sticky-header');
            const stickyBar = document.getElementById('mobile-sticky-bar');
            const headerHeight = header ? header.offsetHeight : 0;
            const stickyBarHeight = (stickyBar && window.getComputedStyle(stickyBar).display !== 'none') ? stickyBar.offsetHeight : 0;
            const offset = headerHeight + stickyBarHeight + 20;

            const elementPosition = productGrid.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = Math.max(0, elementPosition - offset);

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    function showProductsForPage(page) {
        const start = (page - 1) * PRODUCTS_PER_PAGE;
        const end = start + PRODUCTS_PER_PAGE;

        allProducts.forEach((card, index) => {
            if (index >= start && index < end) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }
        });
    }

    function initClientPagination(products) {
        allProducts = products;
        currentPage = 1;
        hideServerPagination();
        showProductsForPage(1);
        renderClientPagination(products.length);
    }

    // -----------------------------
    // ✅ Render Filter Tags (Decathlon-style)
    // -----------------------------
    function renderFilterTags() {
        const checkedBoxes = [...desktopChecks].filter((cb) => cb.checked);
        const count = checkedBoxes.length;

        // Check if price or availability filters are active
        const priceActive = isPriceFilterActive();
        const inStockActive = (inStockFilter && inStockFilter.checked) || (mobileInStockFilter && mobileInStockFilter.checked);
        const totalCount = count + (priceActive ? 1 : 0) + (inStockActive ? 1 : 0);

        // ✅ Update mobile filter badge on sticky bar
        const mobileFilterBadge = document.getElementById('mobile-filter-badge');
        if (mobileFilterBadge) {
            if (totalCount > 0) {
                mobileFilterBadge.textContent = totalCount;
                mobileFilterBadge.classList.remove('hidden');
            } else {
                mobileFilterBadge.classList.add('hidden');
            }
        }

        // ✅ Update mobile scrollable chips bar (#mobile-filter-tags-bar)
        const mobileFilterTagsBar = document.getElementById('mobile-filter-tags-bar');
        if (mobileFilterTagsBar) {
            if (totalCount === 0) {
                mobileFilterTagsBar.innerHTML = '';
                mobileFilterTagsBar.classList.add('hidden');
            } else {
                mobileFilterTagsBar.classList.remove('hidden');
                let mobileChips = checkedBoxes
                    .map(
                        (cb) => `
                    <button type="button" class="mobile-filter-tag shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-white border border-secondary/30 rounded-full text-xs font-medium text-text-main shadow-sm hover:bg-red-50 transition-colors" data-handle="${cb.value}">
                        <span>${cb.dataset.title || cb.value}</span>
                        <span class="material-symbols-outlined text-[14px] text-text-subtle ml-0.5">close</span>
                    </button>
                `
                    )
                    .join('');

                if (priceActive) {
                    mobileChips += `
                    <button type="button" class="mobile-filter-tag shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-white border border-secondary/30 rounded-full text-xs font-medium text-text-main shadow-sm hover:bg-red-50 transition-colors" data-action="clear-price">
                        <span>Price: ${activePriceMin !== null ? 'Rs.' + activePriceMin : '0'} - ${activePriceMax !== null ? 'Rs.' + activePriceMax : 'Max'}</span>
                        <span class="material-symbols-outlined text-[14px] text-text-subtle ml-0.5">close</span>
                    </button>
                    `;
                }

                if (inStockActive) {
                    mobileChips += `
                    <button type="button" class="mobile-filter-tag shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-white border border-secondary/30 rounded-full text-xs font-medium text-text-main shadow-sm hover:bg-red-50 transition-colors" data-action="clear-instock">
                        <span>In Stock</span>
                        <span class="material-symbols-outlined text-[14px] text-text-subtle ml-0.5">close</span>
                    </button>
                    `;
                }

                mobileChips += `
                    <button type="button" class="shrink-0 text-xs font-bold text-primary underline ml-1 py-1" id="mobile-tags-clear-all">Clear All</button>
                `;

                mobileFilterTagsBar.innerHTML = mobileChips;

                // Bind mobile chip removal clicks
                mobileFilterTagsBar.querySelectorAll('.mobile-filter-tag').forEach((tag) => {
                    tag.addEventListener('click', () => {
                        if (tag.dataset.handle) {
                            syncCategoryCheckbox(tag.dataset.handle, false);
                            applyFilters(desktopChecks);
                        } else if (tag.dataset.action === 'clear-price') {
                            clearPriceFilter();
                        } else if (tag.dataset.action === 'clear-instock') {
                            if (inStockFilter) inStockFilter.checked = false;
                            if (mobileInStockFilter) mobileInStockFilter.checked = false;
                            applyAvailabilityFilter({ target: { checked: false } });
                        }
                    });
                });

                document.getElementById('mobile-tags-clear-all')?.addEventListener('click', () => {
                    window.location.href = ALL_PRODUCTS_URL;
                });
            }
        }

        // Update category count (Desktop)
        if (categoryCount) {
            categoryCount.textContent = `(${count})`;
        }

        // Show/hide Remove All link (Desktop)
        if (removeAllLink) {
            removeAllLink.classList.toggle('hidden', totalCount === 0);
        }

        // ✅ Update "Results for:" label in Collection Header
        const activeLabel = document.getElementById('active-filters-label');
        const activeText = activeLabel?.querySelector('.active-filters-text');
        
        if (activeLabel && activeText) {
            if (totalCount > 0) {
                const names = checkedBoxes.map(cb => cb.dataset.title || cb.value);
                if (priceActive) names.push(`Price: ${activePriceMin !== null ? 'Rs.' + activePriceMin : '0'}-${activePriceMax !== null ? 'Rs.' + activePriceMax : 'Max'}`);
                if (inStockActive) names.push('In Stock');
                activeText.textContent = names.join(', ');
                activeLabel.classList.remove('hidden');
            } else {
                activeLabel.classList.add('hidden');
                activeText.textContent = '';
            }
        }

        // Render tags (Desktop)
        if (filterTagsContainer) {
            if (count === 0 && !priceActive && !inStockActive) {
                filterTagsContainer.innerHTML = '';
                return;
            }

            let desktopChipsHTML = checkedBoxes
                .map(
                    (cb) => `
          <button 
            type="button" 
            class="filter-tag inline-flex items-center gap-1 px-3 py-1.5 bg-secondary/10 border border-secondary/30 rounded-full text-sm text-text-main hover:bg-secondary/20 transition-colors"
            data-handle="${cb.value}"
          >
            <span class="text-text-subtle text-xs">Category:</span>
            <span class="font-medium">${cb.dataset.title || cb.value}</span>
            <span class="material-symbols-outlined text-[14px] text-text-subtle hover:text-red-500 ml-1">close</span>
          </button>
        `
                )
                .join('');

            if (priceActive) {
                desktopChipsHTML += `
          <button 
            type="button" 
            class="filter-tag inline-flex items-center gap-1 px-3 py-1.5 bg-secondary/10 border border-secondary/30 rounded-full text-sm text-text-main hover:bg-secondary/20 transition-colors"
            data-action="clear-price"
          >
            <span class="text-text-subtle text-xs">Price:</span>
            <span class="font-medium">${activePriceMin !== null ? 'Rs.' + activePriceMin : '0'} - ${activePriceMax !== null ? 'Rs.' + activePriceMax : 'Max'}</span>
            <span class="material-symbols-outlined text-[14px] text-text-subtle hover:text-red-500 ml-1">close</span>
          </button>
                `;
            }

            if (inStockActive) {
                desktopChipsHTML += `
          <button 
            type="button" 
            class="filter-tag inline-flex items-center gap-1 px-3 py-1.5 bg-secondary/10 border border-secondary/30 rounded-full text-sm text-text-main hover:bg-secondary/20 transition-colors"
            data-action="clear-instock"
          >
            <span class="font-medium">In Stock</span>
            <span class="material-symbols-outlined text-[14px] text-text-subtle hover:text-red-500 ml-1">close</span>
          </button>
                `;
            }

            filterTagsContainer.innerHTML = desktopChipsHTML;

            // Add click handlers for tag removal
            filterTagsContainer.querySelectorAll('.filter-tag').forEach((tag) => {
                tag.addEventListener('click', () => {
                    if (tag.dataset.handle) {
                        const handle = tag.dataset.handle;
                        syncCategoryCheckbox(handle, false);
                        applyFilters(desktopChecks);
                    } else if (tag.dataset.action === 'clear-price') {
                        clearPriceFilter();
                    } else if (tag.dataset.action === 'clear-instock') {
                        if (inStockFilter) inStockFilter.checked = false;
                        if (mobileInStockFilter) mobileInStockFilter.checked = false;
                        applyAvailabilityFilter({ target: { checked: false } });
                    }
                });
            });
        }
    }

    // Call on page load
    renderFilterTags();

    // -----------------------------
    // ✅ Auto-scroll to product grid on server pagination reload (H2 Fix)
    // -----------------------------
    if (window.location.search.includes('page=') && window.innerWidth < 1024) {
        setTimeout(() => {
            if (productGrid) {
                const header = document.querySelector('#sticky-header');
                const stickyBar = document.getElementById('mobile-sticky-bar');
                const headerHeight = header ? header.offsetHeight : 0;
                const stickyBarHeight = (stickyBar && window.getComputedStyle(stickyBar).display !== 'none') ? stickyBar.offsetHeight : 0;
                const offset = headerHeight + stickyBarHeight + 16;

                const elementPosition = productGrid.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = Math.max(0, elementPosition - offset);

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 150);
    }

    // -----------------------------
    // ✅ Parse URL for multi-category state
    // -----------------------------
    const urlParams = new URLSearchParams(window.location.search);
    const categoriesParam = urlParams.get('categories');

    if (categoriesParam) {
        const categories = categoriesParam.split(',').filter(Boolean);

        // Update breadcrumb
        if (categories.length >= 1 && breadcrumbText) {
            // Add Shop link if not present
            const nav = breadcrumbText.closest('nav');
            if (nav && !nav.querySelector('a[href*="all"]')) {
                const chevron = document.createElement('span');
                chevron.className = 'material-symbols-outlined text-gray-300 text-[16px]';
                chevron.textContent = 'chevron_right';

                const shopLink = document.createElement('a');
                shopLink.href = ALL_PRODUCTS_URL;
                shopLink.className = 'text-text-subtle hover:text-primary transition-colors';
                shopLink.textContent = 'Shop';

                breadcrumbText.parentNode.insertBefore(shopLink, breadcrumbText);
                breadcrumbText.parentNode.insertBefore(chevron, breadcrumbText);
            }
            if (categories.length === 1) {
                const cb = document.querySelector(`.js-filter-checkbox[value="${categories[0]}"]`);
                breadcrumbText.textContent = cb ? cb.dataset.title : 'Filtered Results';
            } else {
                breadcrumbText.textContent = 'Filtered Results';
            }
        }

        // Check the corresponding checkboxes
        categories.forEach((handle) => {
            const cb = document.querySelector(`.js-filter-checkbox[value="${handle}"]`);
            if (cb) cb.checked = true;
            const mcb = document.querySelector(`.js-mobile-filter-checkbox[value="${handle}"]`);
            if (mcb) mcb.checked = true;
        });

        // Fetch and render products from multiple collections
        if (categories.length >= 1) {
            showSkeletonLoader(8);

            // ✅ FIX: Pass current sort_by to AJAX fetch so sort is preserved
            const currentSortBy = urlParams.get('sort_by') || '';
            const sortParam = currentSortBy ? `&sort_by=${currentSortBy}` : '';

            Promise.all(categories.map((h) => fetch(`/collections/${h}?view=ajax${sortParam}`).then((r) => r.text()))).then(
                (htmlArray) => {
                    productGrid.innerHTML = '';
                    const seen = new Set();
                    const products = [];

                    htmlArray.forEach((html) => {
                        const tmp = document.createElement('div');
                        tmp.innerHTML = html;

                        tmp.querySelectorAll('.product-card').forEach((card) => {
                            const handle = card.dataset.handle;
                            if (!seen.has(handle)) {
                                seen.add(handle);
                                const clonedCard = card.cloneNode(true);
                                prepareCardForInjection(clonedCard, products.length);
                                productGrid.appendChild(clonedCard);
                                products.push(clonedCard);
                            }
                        });
                    });

                    // Update dynamic product count
                    updateProductCount(products.length);

                    // Initialize cart handler for new cards
                    if (window.EngoodCart) {
                        window.EngoodCart.getCart().then((cart) => window.EngoodCart.syncCards(cart));
                    }

                    // Show empty state if no products
                    if (products.length === 0) {
                        productGrid.innerHTML = `
                <div class="col-span-full py-12 text-center">
                  <p class="text-text-subtle text-lg mb-4">No products found matching your selection.</p>
                  <a href="${CURRENT_COLLECTION_URL}" class="text-primary font-bold hover:underline">Clear All Filters</a>
                </div>
              `;
                        hideServerPagination();
                    } else {
                        // Initialize client-side pagination
                        initClientPagination(products);
                    }
                }
            ).catch((error) => {
                console.error('Failed to fetch products:', error);
                productGrid.innerHTML = `
                  <div class="col-span-full py-12 text-center">
                    <span class="material-symbols-outlined text-4xl text-red-400 mb-2">error</span>
                    <p class="text-text-subtle mb-4">Failed to load products. Please try again.</p>
                    <a href="${ALL_PRODUCTS_URL}" class="text-primary font-bold hover:underline">View All Products</a>
                  </div>
                `;
            });
        }
    }

    // -----------------------------
    // ✅ Sticky bar top offset
    // -----------------------------
    function setStickyTopOffset() {
        const headerWrap = document.querySelector('#sticky-header');
        const spacer = document.getElementById('mobile-filter-spacer');

        if (!headerWrap || !stickyBar) return;

        const headerHeight = headerWrap.offsetHeight;
        stickyBar.style.top = headerHeight + 'px';
        if (spacer && window.getComputedStyle(stickyBar).position === 'fixed') {
            spacer.style.height = stickyBar.offsetHeight + 2 + 'px';
        } else if (spacer) {
            spacer.style.height = '0px';
        }
    }

    setStickyTopOffset();
    window.addEventListener('resize', setStickyTopOffset);

    // -----------------------------
    // ✅ Drawer logic
    // -----------------------------
    function toggleDrawer(open) {
        if (!drawer) return;
        drawer.classList.toggle('invisible', !open);
        drawer.classList.toggle('opacity-0', !open);
        drawerPanel?.classList.toggle('translate-y-full', !open);
        document.body.style.overflow = open ? 'hidden' : '';
    }

    document.getElementById('mobile-filter-trigger')?.addEventListener('click', () => toggleDrawer(true));
    document.getElementById('mobile-filter-close')?.addEventListener('click', () => toggleDrawer(false));
    document.getElementById('mobile-filter-backdrop')?.addEventListener('click', () => toggleDrawer(false));

    // -----------------------------
    // ✅ Filter Logic
    // - 0 selected: go to /collections/all (reload)
    // - 1 selected: go to /collections/{handle} (reload)
    // - 1→2 selected: reload with ?categories=a,b
    // - 2→3+ selected: AJAX only, no reload
    // -----------------------------

    // Track the initial count from URL (used to detect if we need reload)
    const initialCount = categoriesParam
        ? categoriesParam.split(',').filter(Boolean).length
        : window.location.pathname !== ALL_PRODUCTS_URL
            ? 1
            : 0;

    function fetchAndRenderProducts(selected) {
        // Show loading
        showSkeletonLoader(8);

        // Update URL without reload — preserve existing sort_by param
        const url = new URL(window.location.origin + ALL_PRODUCTS_URL);
        url.searchParams.set('categories', selected.join(','));
        const currentSortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (currentSortBy) url.searchParams.set('sort_by', currentSortBy);
        window.history.replaceState({}, '', url);

        // Update breadcrumb
        if (breadcrumbText) {
            if (selected.length === 1) {
                const cb = document.querySelector(`.js-filter-checkbox[value="${selected[0]}"]`);
                breadcrumbText.textContent = cb ? cb.dataset.title : 'Filtered Results';
            } else {
                breadcrumbText.textContent = 'Filtered Results';
            }
        }

        // ✅ FIX: Pass sort_by to each AJAX fetch so sort order is preserved
        const sortParam = currentSortBy ? `&sort_by=${currentSortBy}` : '';

        // Fetch products
        Promise.all(selected.map((h) => fetch(`/collections/${h}?view=ajax${sortParam}`).then((r) => r.text()))).then((htmlArray) => {
            productGrid.innerHTML = '';
            const seen = new Set();
            const products = [];

            htmlArray.forEach((html) => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html;

                tmp.querySelectorAll('.product-card').forEach((card) => {
                    const handle = card.dataset.handle;
                    if (!seen.has(handle)) {
                        seen.add(handle);
                        const clonedCard = card.cloneNode(true);
                        prepareCardForInjection(clonedCard, products.length);
                        productGrid.appendChild(clonedCard);
                        products.push(clonedCard);
                    }
                });
            });

            // Update dynamic product count
            updateProductCount(products.length);

            // Initialize cart handler for new cards
            if (window.EngoodCart) {
                window.EngoodCart.getCart().then((cart) => window.EngoodCart.syncCards(cart));
            }

            // Show empty state if no products
            if (products.length === 0) {
                productGrid.innerHTML = `
              <div class="col-span-full py-12 text-center">
                <p class="text-text-subtle text-lg mb-4">No products found matching your selection.</p>
                <a href="${CURRENT_COLLECTION_URL}" class="text-primary font-bold hover:underline">Clear All Filters</a>
              </div>
            `;
                hideServerPagination();
            } else {
                // Initialize client-side pagination
                initClientPagination(products);
            }
        }).catch((error) => {
            console.error('Failed to fetch products:', error);
            productGrid.innerHTML = `
              <div class="col-span-full py-12 text-center">
                <span class="material-symbols-outlined text-4xl text-red-400 mb-2">error</span>
                <p class="text-text-subtle mb-4">Failed to load products. Please try again.</p>
                <a href="${ALL_PRODUCTS_URL}" class="text-primary font-bold hover:underline">View All Products</a>
              </div>
            `;
        });
    }

    function applyFilters(checkboxes) {
        const selected = [...checkboxes].filter((c) => c.checked).map((c) => c.value);
        const currentCount = selected.length;

        // Update filter tags UI immediately
        renderFilterTags();

        if (currentCount === 0) {
            // No selection — always go to all products, never back to a specific collection
            window.location.href = ALL_PRODUCTS_URL;
        } else {
            // 1 or more categories - always use AJAX for smooth experience
            fetchAndRenderProducts(selected);
        }
    }

    // Sync category checkboxes between desktop and mobile
    function syncCategoryCheckbox(handle, isChecked) {
        const desktopCb = document.querySelector(`.js-filter-checkbox[value="${handle}"]`);
        const mobileCb = document.querySelector(`.js-mobile-filter-checkbox[value="${handle}"]`);
        if (desktopCb) desktopCb.checked = isChecked;
        if (mobileCb) mobileCb.checked = isChecked;
    }

    // Desktop checkbox - sync and apply on change
    desktopChecks.forEach((cb) => {
        cb.addEventListener('change', () => {
            syncCategoryCheckbox(cb.value, cb.checked);
            applyFilters(desktopChecks);
        });
    });

    // Mobile checkbox - sync on change (apply only happens on button click)
    mobileChecks.forEach((cb) => {
        cb.addEventListener('change', () => {
            syncCategoryCheckbox(cb.value, cb.checked);
        });
    });

    // Mobile Apply button — unified atomic execution of all pending filter states (C3 fix)
    document.getElementById('mobile-filter-apply')?.addEventListener('click', () => {
        toggleDrawer(false);
        applyMobileFilters();
    });

    // Clear all — always go to all products, not back to a specific collection
    document.getElementById('mobile-filter-clear')?.addEventListener('click', () => {
        window.location.href = ALL_PRODUCTS_URL;
    });

    // Search categories (debounced 150ms for smooth mobile keyboard typing)
    let categorySearchTimeout;
    document.getElementById('mobile-category-search')?.addEventListener('input', (e) => {
        clearTimeout(categorySearchTimeout);
        const term = e.target.value.toLowerCase();
        categorySearchTimeout = setTimeout(() => {
            document.querySelectorAll('.mobile-cat-item').forEach((item) => {
                item.style.display = item.textContent.toLowerCase().includes(term) ? 'flex' : 'none';
            });
        }, 150);
    });

    // -----------------------------
    // ✅ H4: In-Collection Keyword Search
    // Debounced 250ms client-side title search.
    // Composes with active price and availability filters via runCombinedFilters.
    // -----------------------------
    let activeSearchTerm = '';
    let inCollectionSearchTimeout;

    const inCollectionSearchInput = document.getElementById('mobile-in-collection-search');
    const inCollectionSearchClear = document.getElementById('mobile-collection-search-clear');
    const mobileSearchResultCount = document.getElementById('mobile-search-result-count');

    function applyInCollectionSearch() {
        const term = activeSearchTerm.toLowerCase().trim();
        const pool = allProducts.length > 0
            ? allProducts
            : [...document.querySelectorAll('.product-card')];

        if (!term) {
            // No search term — show all matching price+availability filters
            pool.forEach((card) => (card.style.display = ''));
            if (mobileSearchResultCount) mobileSearchResultCount.classList.add('hidden');
            runCombinedFilters();
            return;
        }

        // Apply search filter on top of current product pool
        const inStockOnly = inStockFilter?.checked || false;

        const filtered = pool.filter((card) => {
            const title = (card.dataset.title || '').toLowerCase();
            if (!title.includes(term)) return false;
            if (inStockOnly && card.dataset.available !== 'true') return false;
            if (activePriceMin !== null || activePriceMax !== null) {
                const price = parseFloat(card.dataset.price || '0');
                if (activePriceMin !== null && price < activePriceMin) return false;
                if (activePriceMax !== null && price > activePriceMax) return false;
            }
            return true;
        });

        // Hide all, then show filtered
        pool.forEach((card) => (card.style.display = 'none'));
        productGrid?.querySelector('.price-empty-state')?.remove();

        // Re-paginate the search results
        const savedAll = allProducts;
        allProducts = filtered;
        currentPage = 1;
        hideServerPagination();
        showProductsForPage(1);
        renderClientPagination(filtered.length);
        allProducts = savedAll;

        updateProductCount(filtered.length);

        // Show result count hint
        if (mobileSearchResultCount) {
            mobileSearchResultCount.textContent = filtered.length === 0
                ? `No products found for "${term}"`
                : `${filtered.length} product${filtered.length === 1 ? '' : 's'} found`;
            mobileSearchResultCount.classList.remove('hidden');
        }
    }

    inCollectionSearchInput?.addEventListener('input', (e) => {
        clearTimeout(inCollectionSearchTimeout);
        activeSearchTerm = e.target.value;

        // Toggle clear button visibility
        if (inCollectionSearchClear) {
            inCollectionSearchClear.classList.toggle('hidden', !activeSearchTerm);
        }

        inCollectionSearchTimeout = setTimeout(() => {
            applyInCollectionSearch();
        }, 250);
    });

    inCollectionSearchClear?.addEventListener('click', () => {
        if (inCollectionSearchInput) inCollectionSearchInput.value = '';
        activeSearchTerm = '';
        inCollectionSearchClear.classList.add('hidden');
        if (mobileSearchResultCount) mobileSearchResultCount.classList.add('hidden');
        applyInCollectionSearch();
        inCollectionSearchInput?.focus();
    });

    // Clear search state when drawer closes
    const originalToggleDrawer = toggleDrawer;
    function toggleDrawerWithSearchReset(open) {
        if (!open && activeSearchTerm) {
            // Keep the search result visible after drawer closes — don't auto-reset
            // Shoppers should see their search results persist on the grid
        }
        originalToggleDrawer(open);
    }

    // Clear search when "Clear All" is clicked
    document.getElementById('mobile-filter-clear')?.addEventListener('click', () => {
        if (inCollectionSearchInput) inCollectionSearchInput.value = '';
        activeSearchTerm = '';
        if (inCollectionSearchClear) inCollectionSearchClear.classList.add('hidden');
        if (mobileSearchResultCount) mobileSearchResultCount.classList.add('hidden');
    }, { capture: false });

    // -----------------------------
    // ✅ C3 FIX: Mobile Drawer Pending State
    // Selections inside the open drawer are stored here.
    // Nothing executes until "Apply Filters" is tapped.
    // -----------------------------
    let pendingMobileSort = null;       // null = no change pending
    let pendingMobileInStock = null;    // null = no change pending

    function isDrawerOpen() {
        return drawer && !drawer.classList.contains('invisible');
    }

    // -----------------------------
    // ✅ Sort Functionality
    // -----------------------------
    const sortSelect = document.getElementById('collection-sort');
    const mobileSortSelect = document.getElementById('mobile-collection-sort');

    // ✅ FIX: Sync mobile sort dropdown to match current URL sort value
    const currentSortValue = urlParams.get('sort_by');
    if (currentSortValue && mobileSortSelect) {
        mobileSortSelect.value = currentSortValue;
    }

    function fetchSingleCollectionSorted(handle, sortValue) {
        // Show loading
        showSkeletonLoader(8);

        fetch(`/collections/${handle}?view=ajax&sort_by=${sortValue}`)
            .then((r) => r.text())
            .then((html) => {
                productGrid.innerHTML = '';
                const tmp = document.createElement('div');
                tmp.innerHTML = html;

                const products = Array.from(tmp.querySelectorAll('.product-card'));
                products.forEach((card, idx) => {
                    prepareCardForInjection(card, idx);
                    productGrid.appendChild(card);
                });

                updateProductCount(products.length);

                if (window.EngoodCart) {
                    window.EngoodCart.getCart().then((cart) => window.EngoodCart.syncCards(cart));
                }

                if (products.length === 0) {
                    productGrid.innerHTML = `
                        <div class="col-span-full py-12 text-center">
                            <p class="text-text-subtle text-lg mb-4">No products found.</p>
                        </div>
                    `;
                    hideServerPagination();
                } else {
                    initClientPagination(products);
                    runCombinedFilters(); // Apply any price/availability filters on top
                }
            })
            .catch((error) => {
                console.error('Failed to fetch sorted products:', error);
                productGrid.innerHTML = `
                    <div class="col-span-full py-12 text-center">
                        <p class="text-text-subtle mb-4">Failed to load products. Please try again.</p>
                    </div>
                `;
            });
    }

    function applySortFilter(sortValue) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.history.replaceState({}, '', url.toString());

        const checkedBoxes = [...desktopChecks].filter((c) => c.checked).map((c) => c.value);
        if (checkedBoxes.length > 0) {
            // Custom multi-category AJAX fetch
            fetchAndRenderProducts(checkedBoxes);
        } else {
            // Single collection AJAX fetch
            const pathParts = window.location.pathname.split('/').filter(Boolean);
            const currentHandle = pathParts.includes('collections') ? pathParts[pathParts.indexOf('collections') + 1] : 'all';
            fetchSingleCollectionSorted(currentHandle || 'all', sortValue);
        }
    }

    // Desktop sort: always execute immediately (drawer is never open on desktop)
    sortSelect?.addEventListener('change', (e) => applySortFilter(e.target.value));

    // Mobile sort: if drawer is open, store as pending state — do NOT execute yet
    mobileSortSelect?.addEventListener('change', (e) => {
        if (isDrawerOpen()) {
            pendingMobileSort = e.target.value;
        } else {
            applySortFilter(e.target.value);
        }
    });

    // ✅ Price Range Filter (Client-side — Option B)
    // -----------------------------

    function updatePriceClearBtn() {
        if (isPriceFilterActive()) {
            clearPriceBtn?.classList.remove('hidden');
            removeAllLink?.classList.remove('hidden');
        } else {
            clearPriceBtn?.classList.add('hidden');
        }
    }

    function applyPriceFilter() {
        // Read values from whichever input was used
        const rawMin = priceMinInput?.value !== '' ? priceMinInput?.value : mobilePriceMinInput?.value || '';
        const rawMax = priceMaxInput?.value !== '' ? priceMaxInput?.value : mobilePriceMaxInput?.value || '';

        const min = rawMin !== '' ? parseFloat(rawMin) : null;
        const max = rawMax !== '' ? parseFloat(rawMax) : null;

        // Swap silently if min > max
        if (min !== null && max !== null && min > max) {
            activePriceMin = max;
            activePriceMax = min;
        } else {
            activePriceMin = min;
            activePriceMax = max;
        }

        // Sync all inputs
        if (priceMinInput) priceMinInput.value = activePriceMin !== null ? activePriceMin : '';
        if (mobilePriceMinInput) mobilePriceMinInput.value = activePriceMin !== null ? activePriceMin : '';
        if (priceMaxInput) priceMaxInput.value = activePriceMax !== null ? activePriceMax : '';
        if (mobilePriceMaxInput) mobilePriceMaxInput.value = activePriceMax !== null ? activePriceMax : '';

        updatePriceClearBtn();
        runCombinedFilters();
    }

    function clearPriceFilter() {
        activePriceMin = null;
        activePriceMax = null;

        if (priceMinInput) priceMinInput.value = '';
        if (mobilePriceMinInput) mobilePriceMinInput.value = '';
        if (priceMaxInput) priceMaxInput.value = '';
        if (mobilePriceMaxInput) mobilePriceMaxInput.value = '';

        updatePriceClearBtn();
        runCombinedFilters();
    }

    // Run all active client-side filters together and re-init pagination
    function runCombinedFilters() {
        // Pool = AJAX-fetched cards (when category filter active) or all server-rendered cards
        const pool = allProducts.length > 0
            ? allProducts
            : [...document.querySelectorAll('.product-card')];

        const inStockOnly = document.getElementById('filter-in-stock')?.checked || false;

        const filtered = pool.filter((card) => {
            if (inStockOnly && card.dataset.available !== 'true') return false;

            if (activePriceMin !== null || activePriceMax !== null) {
                const price = parseFloat(card.dataset.price || '0');
                if (activePriceMin !== null && price < activePriceMin) return false;
                if (activePriceMax !== null && price > activePriceMax) return false;
            }

            return true;
        });

        // Hide all, then show filtered
        pool.forEach((card) => (card.style.display = 'none'));
        productGrid?.querySelector('.price-empty-state')?.remove();

        if (filtered.length === 0) {
            const emptyDiv = document.createElement('div');
            emptyDiv.className = 'col-span-full py-12 text-center price-empty-state';
            emptyDiv.innerHTML = `
                <p class="text-text-subtle text-lg mb-4">No products found in this price range.</p>
                <button id="clear-price-empty-btn" class="text-primary font-bold hover:underline">Clear Price Filter</button>
            `;
            productGrid?.appendChild(emptyDiv);
            document.getElementById('clear-price-empty-btn')?.addEventListener('click', clearPriceFilter);
            hideServerPagination();
            clientPagination?.classList.add('hidden');
            updateProductCount(0);
            renderFilterTags();
            return;
        }

        // Temporarily reassign allProducts to the filtered set for pagination
        const savedAll = allProducts;
        allProducts = filtered;
        currentPage = 1;
        hideServerPagination();
        showProductsForPage(1);
        renderClientPagination(filtered.length);
        allProducts = savedAll;

        updateProductCount(filtered.length);
        renderFilterTags();
    }

    // Desktop Apply button
    document.getElementById('apply-price-filter')?.addEventListener('click', applyPriceFilter);

    // Clear button
    clearPriceBtn?.addEventListener('click', clearPriceFilter);

    // -----------------------------
    // ✅ Availability Filter (Client-side)
    // -----------------------------

    function applyAvailabilityFilter(e) {
        const checked = e.target.checked;

        // Sync desktop and mobile checkboxes
        if (inStockFilter) inStockFilter.checked = checked;
        if (mobileInStockFilter) mobileInStockFilter.checked = checked;

        // Delegate to combined filter so price + availability compose correctly
        runCombinedFilters();
    }

    // Desktop in-stock: always execute immediately
    inStockFilter?.addEventListener('change', applyAvailabilityFilter);

    // Mobile in-stock: if drawer is open, store as pending state — do NOT execute yet
    mobileInStockFilter?.addEventListener('change', (e) => {
        if (isDrawerOpen()) {
            pendingMobileInStock = e.target.checked;
        } else {
            applyAvailabilityFilter(e);
        }
    });

    // -----------------------------
    // ✅ C3 FIX: Unified Mobile Apply — executes ALL pending filter states atomically
    // Replaces the previous fragmented double-listener pattern.
    // -----------------------------
    function applyMobileFilters() {
        // 1. Apply pending sort if changed
        if (pendingMobileSort !== null) {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', pendingMobileSort);
            window.history.replaceState({}, '', url.toString());
        }

        // 2. Sync pending in-stock state to desktop checkbox so runCombinedFilters reads it correctly
        if (pendingMobileInStock !== null) {
            if (inStockFilter) inStockFilter.checked = pendingMobileInStock;
        }

        // 3. Apply pending price filter from mobile inputs
        const rawMin = mobilePriceMinInput?.value || '';
        const rawMax = mobilePriceMaxInput?.value || '';
        if (rawMin !== '' || rawMax !== '') {
            // Commit price values to activePriceMin/Max via applyPriceFilter logic inline
            const min = rawMin !== '' ? parseFloat(rawMin) : null;
            const max = rawMax !== '' ? parseFloat(rawMax) : null;
            if (min !== null && max !== null && min > max) {
                activePriceMin = max;
                activePriceMax = min;
            } else {
                activePriceMin = min;
                activePriceMax = max;
            }
            // Sync desktop price inputs
            if (priceMinInput) priceMinInput.value = activePriceMin !== null ? activePriceMin : '';
            if (priceMaxInput) priceMaxInput.value = activePriceMax !== null ? activePriceMax : '';
            updatePriceClearBtn();
        }

        // 4. Now execute categories + sort + price + availability as one unified operation
        const selectedCategories = [...mobileChecks].filter((c) => c.checked).map((c) => c.value);
        const pendingSortValue = pendingMobileSort !== null
            ? pendingMobileSort
            : (new URLSearchParams(window.location.search).get('sort_by') || '');

        if (selectedCategories.length === 0) {
            // No categories — navigate to all products (reload preserves sort in URL)
            const targetUrl = new URL(window.location.origin + ALL_PRODUCTS_URL);
            if (pendingSortValue) targetUrl.searchParams.set('sort_by', pendingSortValue);
            window.location.href = targetUrl.toString();
        } else {
            // Fetch products with correct sort, then apply price + availability on top
            const sortParam = pendingSortValue ? `&sort_by=${pendingSortValue}` : '';
            showSkeletonLoader(8);

            // Update URL
            const url = new URL(window.location.origin + ALL_PRODUCTS_URL);
            url.searchParams.set('categories', selectedCategories.join(','));
            if (pendingSortValue) url.searchParams.set('sort_by', pendingSortValue);
            window.history.replaceState({}, '', url);

            // Update breadcrumb
            if (breadcrumbText) {
                if (selectedCategories.length === 1) {
                    const cb = document.querySelector(`.js-filter-checkbox[value="${selectedCategories[0]}"]`);
                    breadcrumbText.textContent = cb ? cb.dataset.title : 'Filtered Results';
                } else {
                    breadcrumbText.textContent = 'Filtered Results';
                }
            }

            Promise.all(
                selectedCategories.map((h) =>
                    fetch(`/collections/${h}?view=ajax${sortParam}`).then((r) => r.text())
                )
            ).then((htmlArray) => {
                productGrid.innerHTML = '';
                const seen = new Set();
                const products = [];

                htmlArray.forEach((html) => {
                    const tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    tmp.querySelectorAll('.product-card').forEach((card) => {
                        const handle = card.dataset.handle;
                        if (!seen.has(handle)) {
                            seen.add(handle);
                            const clonedCard = card.cloneNode(true);
                            prepareCardForInjection(clonedCard, products.length);
                            productGrid.appendChild(clonedCard);
                            products.push(clonedCard);
                        }
                    });
                });

                if (window.EngoodCart) {
                    window.EngoodCart.getCart().then((cart) => window.EngoodCart.syncCards(cart));
                }

                if (products.length === 0) {
                    productGrid.innerHTML = `
                        <div class="col-span-full py-12 text-center">
                          <p class="text-text-subtle text-lg mb-4">No products found matching your selection.</p>
                          <a href="${CURRENT_COLLECTION_URL}" class="text-primary font-bold hover:underline">Clear All Filters</a>
                        </div>
                    `;
                    hideServerPagination();
                } else {
                    allProducts = products;
                    initClientPagination(products);
                    // Apply price + availability on top of the freshly loaded set
                    if (isPriceFilterActive() || (inStockFilter && inStockFilter.checked)) {
                        runCombinedFilters();
                    } else {
                        updateProductCount(products.length);
                    }
                }
            }).catch((error) => {
                console.error('Failed to fetch products:', error);
                productGrid.innerHTML = `
                    <div class="col-span-full py-12 text-center">
                      <span class="material-symbols-outlined text-4xl text-red-400 mb-2">error</span>
                      <p class="text-text-subtle mb-4">Failed to load products. Please try again.</p>
                      <a href="${ALL_PRODUCTS_URL}" class="text-primary font-bold hover:underline">View All Products</a>
                    </div>
                `;
            });
        }

        // Reset pending state after execution
        pendingMobileSort = null;
        pendingMobileInStock = null;
        renderFilterTags();
    }

    // -----------------------------
    // ✅ Smart hide on scroll & Back to Top visibility
    // -----------------------------
    let lastScroll = window.scrollY;
    const backToTopBtn = document.getElementById('back-to-top-btn');

    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    window.addEventListener(
        'scroll',
        () => {
            const y = window.scrollY;

            // Back to Top toggle
            if (backToTopBtn) {
                if (y > 300) {
                    backToTopBtn.style.opacity = '1';
                    backToTopBtn.style.transform = 'translateY(0)';
                    backToTopBtn.style.pointerEvents = 'auto';
                } else {
                    backToTopBtn.style.opacity = '0';
                    backToTopBtn.style.transform = 'translateY(1rem)';
                    backToTopBtn.style.pointerEvents = 'none';
                }
            }

            if (!stickyBar) return;

            if (y < 20) {
                stickyBar.classList.remove('filter-bar-hidden', 'shadow-md');
                lastScroll = y;
                return;
            }

            stickyBar.classList.add('shadow-md');

            // Hysteresis check: only toggle if scroll delta > 10px to prevent jitter (M4 Fix)
            const delta = y - lastScroll;
            if (Math.abs(delta) > 10) {
                if (delta > 0 && y > 300) {
                    // Scrolling down past 300px — hide sticky bar to maximize grid space
                    stickyBar.classList.add('filter-bar-hidden');
                } else if (delta < 0) {
                    // Scrolling up — immediately show sticky bar for quick filter/sort access
                    stickyBar.classList.remove('filter-bar-hidden');
                }
                lastScroll = y;
            }
        },
        { passive: true }
    );

    // -----------------------------
    // ✅ L2: Touch feedback on Out-of-Stock buttons
    // -----------------------------
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.sold-out-btn');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if (navigator.vibrate) {
            navigator.vibrate(40);
        }

        const textSpan = btn.querySelector('.sold-out-text');
        if (textSpan && !btn.dataset.feedbacking) {
            btn.dataset.feedbacking = 'true';
            const originalText = textSpan.textContent;
            textSpan.textContent = 'Item Unavailable';

            setTimeout(() => {
                textSpan.textContent = originalText;
                delete btn.dataset.feedbacking;
            }, 1200);
        }
    });
});